import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpStatusCode,
} from '@angular/common/http'
import {Injectable} from '@angular/core'
import {Observable, retry, throwError, timer} from 'rxjs'

export const maxRetries = 2
export const delayMs = 2000
const excludedPaths = ['/signin', '/send-otp', '/signin-otp']
@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  intercept = (request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> => {
    if (excludedPaths.some(path => request.url.includes(path))) {
      return next.handle(request)
    }

    return next.handle(request).pipe(
      retry({
        count: maxRetries,
        delay: error => (this.isRetriable(error) ? timer(delayMs) : throwError(() => error)),
      })
    )
  }

  private isRetriable(error: HttpErrorResponse): boolean {
    return (
      error.status === HttpStatusCode.InternalServerError ||
      error.status === HttpStatusCode.BadGateway ||
      error.status === HttpStatusCode.GatewayTimeout
    )
  }
}
